import validator from 'validator';
import moment from 'moment';
import {
  isEmptyOrContainsOnlySpaces,
  isNullOrEmpty,
  keyErrorsFieldRequired,
  removeNonDigitCharacters,
} from 'utils/helpers';
import { validateEmail } from '../common/helpers';
import { REGISTRATION_CONSENTS_KEYS } from '../../../consts/loan/AU';

const validateAuthentication = (values) => {
  const errors = {};

  const {
    birthDay,
    birthMonth,
    birthYear,
    email,
    msisdn,
    otp,
    newPassword,
    newPasswordConfirm,
    username,
    recoveryEmail,
  } = values;

  // REGISTRATION
  if (isEmptyOrContainsOnlySpaces(values.firstname)) {
    errors.firstname = keyErrorsFieldRequired;
  }

  if (isEmptyOrContainsOnlySpaces(values.lastName)) {
    errors.lastName = keyErrorsFieldRequired;
  }

  if (!isNullOrEmpty(birthDay) && !isNullOrEmpty(birthMonth) && !isNullOrEmpty(birthYear)) {
    const dateNow = moment();
    const dateOfBirth = moment(`${birthYear}-${birthMonth}-${birthDay}`, 'YYYY-M-D');
    const diff = dateNow.diff(dateOfBirth, 'years');
    if (diff < 18) {
      errors.datePickerUnderage = 'registration.field.underage.error';
      errors.birthDay = keyErrorsFieldRequired;
      errors.birthMonth = keyErrorsFieldRequired;
      errors.birthYear = keyErrorsFieldRequired;
    }
  } else {
    if (isNullOrEmpty(birthDay)) {
      errors.birthDay = keyErrorsFieldRequired;
    }

    if (isNullOrEmpty(birthMonth)) {
      errors.birthMonth = keyErrorsFieldRequired;
    }

    if (isNullOrEmpty(birthYear)) {
      errors.birthYear = keyErrorsFieldRequired;
    }
  }

  if (!email && email !== 0) {
    errors.email = keyErrorsFieldRequired;
  } else if (!validateEmail(email)) {
    errors.email = 'errors.field.email';
  }

  if (!msisdn) {
    errors.msisdn = keyErrorsFieldRequired;
  } else if (!validator.matches(removeNonDigitCharacters(msisdn), /^04\d{8}$/)) {
    errors.msisdn = 'errors.field.msisdn';
  }

  if (!otp) {
    errors.otp = keyErrorsFieldRequired;
  } else if (!validator.matches(otp, /^\d{4}$/)) {
    errors.otp = 'errors.field.otp';
  }

  if (!newPassword) {
    errors.newPassword = keyErrorsFieldRequired;
  } else if (
    newPassword.length < 8
    || newPassword.length > 20
    || !newPassword.match(/[a-z]/i)
    || !newPassword.match(/\d+/g)
  ) {
    errors.newPassword = 'errors.field.newPassword';
  }

  if (!newPasswordConfirm || newPasswordConfirm !== newPassword) {
    errors.newPasswordConfirm = 'errors.field.newPasswordConfirm';
  }

  if (!values.instantMessenger) {
    errors.instantMessenger = keyErrorsFieldRequired;
  }

  REGISTRATION_CONSENTS_KEYS.forEach((checkbox) => {
    if (!values[checkbox]) {
      errors[checkbox] = keyErrorsFieldRequired;
    }
  });

  // LOGIN
  if (!username && username !== 0) {
    errors.username = keyErrorsFieldRequired;
  } else {
    const isUsernameValid = validateEmail(username) || validator.matches(username, /^04\d{8}$/);
    if (!isUsernameValid) {
      errors.username = 'errors.field.username';
    }
  }

  if (!values.login_pass) {
    errors.login_pass = keyErrorsFieldRequired;
  }

  // PASSWORD RESET
  if (!recoveryEmail) {
    errors.recoveryEmail = keyErrorsFieldRequired;
  } else if (!validateEmail(recoveryEmail)) {
    errors.recoveryEmail = 'errors.field.email';
  }

  return errors;
};

export default validateAuthentication;
